import Vue from 'vue'

// ----------------------------------------------------------------------------
// Vue Material
// ----------------------------------------------------------------------------
import {
  MdApp,
  MdButton,
  MdField,
  MdTable,
  MdContent,
  MdRipple,
  MdToolbar,
  MdCard,
  MdProgress,
  MdDialog,
  MdBadge,
  MdCheckbox,
  MdRadio,
  MdChips,
  MdSnackbar,
  MdSwitch,
  MdTabs,
  MdTooltip,
  MdMenu,
  MdList,
  MdSpeedDial,
} from 'vue-material/dist/components'
import 'vue-material/dist/theme/default.css'
import 'vue-material/dist/vue-material.min.css'

Vue.use(MdApp)
Vue.use(MdButton)
Vue.use(MdField)
Vue.use(MdTable)
Vue.use(MdContent)
Vue.use(MdRipple)
Vue.use(MdToolbar)
Vue.use(MdCard)
Vue.use(MdProgress)
Vue.use(MdDialog)
Vue.use(MdBadge)
Vue.use(MdCheckbox)
Vue.use(MdRadio)
Vue.use(MdChips)
Vue.use(MdSnackbar)
Vue.use(MdSwitch)
Vue.use(MdTabs)
Vue.use(MdTooltip)
Vue.use(MdMenu)
Vue.use(MdList)
Vue.use(MdSpeedDial)

// ----------------------------------------------------------------------------
// Fontawesome Icons
// ----------------------------------------------------------------------------
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEdit,
  faTrashAlt,
  faPlus,
  faCog,
  faUser,
  faUsers,
  faSignOutAlt,
  faCheckCircle,
  faTimesCircle,
  faArrowLeft,
  faCrown,
  faKey,
  faCaretRight,
  faCheckSquare,
  faMinusSquare,
  faFolder,
  faFolderOpen,
  faFileDownload,
  faBell,
  faFileUpload,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSquare } from '@fortawesome/free-regular-svg-icons'

library.add(faEdit)
library.add(faTrashAlt)
library.add(faPlus)
library.add(faCog)
library.add(faUser)
library.add(faUsers)
library.add(faSignOutAlt)
library.add(faCheckCircle)
library.add(faTimesCircle)
library.add(faArrowLeft)
library.add(faCrown)
library.add(faKey)
library.add(faCaretRight)
library.add(faCheckSquare)
library.add(faMinusSquare)
library.add(faSquare)
library.add(faFolder)
library.add(faFolderOpen)
library.add(faFileDownload)
library.add(faBell)
library.add(faFileUpload)
library.add(faFileAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)
